import config from "config";
// import { getToken } from "./auth-utils";
import axios from "axios";
// import doToast from "components/doToast/doToast";
import { getToken } from "./auth-token";
import doToast from "components/toast/doToast";

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  async function(error) {
    // Reject promise if usual error
    if (error?.message === "Network Error") {
      doToast("Network Error", "error");
      return Promise.reject(error?.message);
    }

    return Promise.reject(error);
  }
);

export async function client(
  endpoint,
  { body, method, headers: customHeaders, ...customConfig } = {},
  signal
) {
  const token = getToken();

  const headers = {
    "Content-type": "application/json; charset=UTF-8"
  };

  // sets token header if one exists
  if (token) headers.Authorization = `Bearer ${token}`;
  const payload = { ...body };

  // populates axios param property with appropiate header and body

  const params = {
    method: method || (body ? "POST" : "GET"),
    ...customConfig,
    headers: {
      ...headers,
      ...customHeaders
    }
  };

  if (body) params.data = JSON.stringify(payload);

  let response;
  const axiosResponse = await axios(`${config.BASE_URL}/${endpoint}`, params, signal);
  const data = axiosResponse?.data;

  if (data?.data) {
    const { data: resolvedResponse } = data;
    response = resolvedResponse;
  } else {
    response = data;
  }

  return response;
}

export const axiosInstance = axios.create({
  baseURL: config.BASE_URL
  // timeout: 20000
  // headers: { "X-Custom-Header": "foobar" }
});

axiosInstance.interceptors.request.use(
  config => {
    const token = getToken();
    // clientPayload = config?.data;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function(response) {
    return response.data;
  },
  async function(error) {
    // Reject promise if usual error
    if (error?.message === "Network Error") {
      doToast("Network Error", "error");
      return Promise.reject(error?.message);
    }

    return Promise.reject(error);
  }
);

export const vasClient = axios.create({
  baseURL: config.VAS_BASE_URL
  // timeout: 20000
  // headers: { "X-Custom-Header": "foobar" }
});

vasClient.interceptors.request.use(
  config => {
    const token = getToken();
    // clientPayload = config?.data;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

vasClient.interceptors.response.use(
  function(response) {
    return response.data;
  },
  async function(error) {
    // Reject promise if usual error
    if (error?.message === "Network Error") {
      doToast("Network Error", "error");
      return Promise.reject(error?.message);
    }

    return Promise.reject(error);
  }
);
